// Tooltip HTML único, reaproveitado pelo grafo (nós e arestas).
// Padrão visual: fundo surface, borda hairline, ink normal.

let el = null;

function ensure() {
  if (el) return el;
  el = document.createElement('div');
  el.className = 'tooltip';
  document.body.appendChild(el);
  return el;
}

export function showTooltip(html, x, y) {
  const node = ensure();
  node.innerHTML = html;
  node.classList.add('visible');
  moveTooltip(x, y);
}

export function moveTooltip(x, y) {
  const node = ensure();
  const offset = 14;
  const rect = node.getBoundingClientRect();
  let left = x + offset;
  let top = y + offset;
  if (left + rect.width > window.innerWidth) left = x - rect.width - offset;
  if (top + rect.height > window.innerHeight) top = y - rect.height - offset;
  node.style.left = `${left}px`;
  node.style.top = `${top}px`;
}

export function hideTooltip() {
  if (el) el.classList.remove('visible');
}
